import $ from '../utils/jquery';

const $feed = $( '#flipcard-feed' );
let $btn;

const toggleCard = ( $card ) => {
	if ( $card.hasClass( 'flipped' ) ) {
		$card.removeClass( 'flipped' );
	} else {
		var $flippedCard = $( '.flip-card.flipped' );

		if ( $flippedCard.length ) {
			$flippedCard.removeClass( 'flipped' );
		}

		$card.addClass( 'flipped' );
	}
}

const bind = () => {
	$btn.on( 'click', function( e ) {
		const $card = $( this ).closest( '.flip-card' );
		toggleCard( $card );
	} );
}

export default () => {
	if ( ! $feed.length ) {
		return;
	}

	$btn = $( '.flip-btn' );

	bind();
};
